<ion-header>
  <top-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></top-nav-component>
</ion-header>

<ion-content>

  <bloc-header-comp [compOptions]="{'title': blocHeaderTitle, 'isBackBtn': true, 'url': 'edit-profil', loading: !callsDone}"></bloc-header-comp>
  
  <!-- FORM TEMPLATE ERRORS -->
  <ng-template #errorTemplate let-field="field">
    <ng-container *ngIf="!field.valid && (field.dirty || field.touched)">
      <span class="field-error" *ngIf="field.errors?.required">Ce champ est obligatoire</span>
      <span class="field-error" *ngIf="field.errors?.pattern">Ce champ n'est pas valide</span>
      <span class="field-error" *ngIf="field.errors?.minlength">Doit contenir au moins 6 caractères</span>
      <span class="field-error" *ngIf="field.errors?.maxlength">Nombre de caractères maximum dépassé</span>
      <span class="field-error" *ngIf="field.errors?.validatePasswords">Les mots de passe ne correspondent pas</span>
      <!-- {{field.errors?.validatePasswords | json}} -->
    </ng-container>
  </ng-template>

  <div class="deleteAccount">
    <!-- <div *ngIf="!callsDone" class="change-email-container" [ngClass]="{'evs-card-ui': true, 'animated fadeIn': (!isCordova && isDesktop)}">
      <div class="wpe-50 margin-top-10 border-radius-12 padding-12 margin-auto shimmer"></div>
      <div class="wpe-100 border-radius-6 padding-6 margin-top-30 shimmer"></div>
      <div class="wpe-100 border-radius-6 padding-6 margin-top-15 shimmer"></div>
      <div class="wpe-40 border-radius-6 padding-6 margin-top-15 shimmer"></div>
      <div class="margin-top-40">
        <div class="wpi-120 border-radius-6 padding-6 shimmer"></div>
        <div class="wpe-100 margin-top-15 border-bottom-1 border-gray-90 shimmer"></div>
      </div>
      <div class="margin-top-40">
        <div class="wpi-120 border-radius-6 padding-6 shimmer"></div>
        <div class="wpe-100 margin-top-15 border-bottom-1 border-gray-90 shimmer"></div>
      </div>
      <div class="margin-top-40">
        <div class="wpi-120 border-radius-6 padding-6 shimmer"></div>
        <div class="wpe-100 margin-top-15 border-bottom-1 border-gray-90 shimmer"></div>
      </div>
      <div class="wpe-100 border-radius-6 hpi-45 margin-top-40 shimmer"></div>
    </div> -->
    <div *ngIf="!accountJustDeleted && !displayCodePage" class="evs-card-ui delete-account-container form-item">
      <p class="delete-desc">
        En validant ce formulaire, ton compte sera définitivement supprimé.<br>
        <b>Es-tu sûr&nbsp;?</b>
      </p>
      <form *ngIf="formConstructed" [formGroup]="deleteAccountForm" autocomplete="off" class="evs-form" (ngSubmit)="submitDeleteAccountForm(deleteAccountForm.value)" #userProfileFormHTML>
        <autocomplete-local-comp class='motif-input' [compOptions]="{id: 'reasonAutoComp', type: 'select', 'placeholder': 'Choisis un motif', 'fields': ['name'], 'fieldname': 'name', 'output': 'value', value: '', selectData: reasonList}" (inputSelected)="getAutocompleteSelectValue(deleteAccountForm, 'reason', $event)"></autocomplete-local-comp>
        <div class='reason-textarea' *ngIf="deleteAccountForm.controls.reason.value === 'Autre raison'">
          <textarea rows="5" id="reason" formControlName="reasonText" [(ngModel)]="reason"></textarea>
          <label for="reasonText" [ngClass]="{'label-up': reasonText !== ''}">Précise la raison</label>
        </div>
        <div *ngIf='deleteAccountForm.controls.reason.value != ""' class="delete-button margin-top-20 margin-bottom-20 text-center text-warning">
          <loading-button-comp class="wpe-100" [compOptions]="{loading: isChangingEmail, type: 'submit', disabled: !deleteAccountForm.valid || !callsDone, text: displayCode ? 'Valider' :'Supprimer mon compte'}" (hasClicked)="handleClick($event)"></loading-button-comp>
        </div>
      </form>
      <!-- <form *ngIf="formConstructed" [formGroup]="deleteAccountForm" autocomplete="off" class="evs-form" (ngSubmit)="submitDeleteAccountForm(deleteAccountForm.value)" #userProfileFormHTML>
        <div>
          <textarea rows="5" id="reason" formControlName="reason" [(ngModel)]="reason"></textarea>
          <label for="reason" [ngClass]="{'label-up': reason !== ''}">Avant de partir, dis-nous pourquoi tu supprimes ton compte</label>
        </div>
        <div class="margin-top-20 margin-bottom-20 text-center text-warning">
          <loading-button-comp class="wpe-100" [compOptions]="{loading: isChangingEmail, type: 'submit', disabled: !deleteAccountForm.valid || !callsDone}" (hasClicked)="handleClick($event)"></loading-button-comp>
        </div>
        <div class="margin-v-20 text-center text-warning">
          <a class="link" (click)="openLink('aideSuppressionCompte')">En savoir plus</a>
        </div>
      </form> -->
    </div>
    <div *ngIf="displayCodePage" class="evs-card-ui delete-account-container-code form-item">
      <img src="assets/svg/lecons.svg" alt="EnVoitureSimone">
      <p class="delete-desc">
        Félicitations pour ton code
        🎉Savais-tu qu’avec En Voiture Simone, tu peux prendre des <b>leçons de conduite</b> et <b>passer ton permis</b> ?
      </p>
      <div class="button-box margin-bottom-33 text-center text-warning">
        <loading-button-comp (click)="handleClick('offers')" class="offer-button wpe-100" [compOptions]="{loading: isChangingEmail, type: 'submit', disabled: !callsDone, text: 'Consulter l\'offre permis'}" (hasClicked)="handleClick($event)"></loading-button-comp>
        <loading-button-comp (click)="handleClick('delete')" class="delete-button wpe-100" [compOptions]="{id: 'deleteButton', loading: isChangingEmail, type: 'submit', disabled: !callsDone, text: 'Supprimer mon compte'}" (hasClicked)="handleClick($event)"></loading-button-comp>
      </div>
    </div>
  </div>

  <modal-comp [compOptions]="{'id': 'customModalUpload1', size: 'small'}" *ngIf="showModal1" (canClose)="hideModal1()">
    <div class="text-center">{{errorMsg | json}}</div>
  </modal-comp>

  <modal-comp [compOptions]="{'id': 'customModalLoadingData', size: 'small', closable: false}" *ngIf="displayModalDisconnect" (canClose)="hideModalDisconnect()">
    <div class="text-center">
      <ion-spinner class="customSpinner margin-top-10" name="crescent"></ion-spinner>
      <br>
      <div class="flip-box flip-up margin-top-10" [ngClass]="{'box-fx': isBoxFx}">
        <div class="object" #flipBox>
          <div class="front">
            <span class="callout" [innerHTML]="sentence1">Déconnexion en cours</span>
          </div>
          <div class="back">
            <span class="callout" [innerHTML]="sentence2"></span>
          </div>
          <div class="top"></div>
          <div class="bottom"></div>
        </div>
      </div>
    </div>
  </modal-comp>

</ion-content>

<ion-footer>
  <footer-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></footer-nav-component>
</ion-footer>
